<template>
  <div>
    <Banner
      :titulo="banner.title"
      :image="banner.image"
      :respimage="banner.resp_image"
    />
    <!-- <div v-for="(block, key) in this.blocks"> 

      <Block3
        :title="title"
        :figure="blocks[key].image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        v-if="blocks[key].block_type === 3"
      />

    </div> -->
    <section id="block3" class="blocks" style="background: rgb(255, 255, 255);">
      <div class="container">
        <h2 class="title-box">POLÍTICA DE PRIVACIDADE</h2>
        <article class="article-blocks">
          <div>
            <p class="texto">
              A <em><strong>STORM GROUP</strong></em> é uma prestadora de
              serviços e integradora de soluções completas em tecnologia, desde
              o desenvolvimento de soluções descomplicadas e inovadoras para o
              seu negócio, quanto para a manutenção de sistemas de alta
              performance até a criação de aplicativos para Internet e
              celulares.
            </p>

            <p class="texto">
              Para a <em><strong>STORM GROUP</strong></em
              >, a sua privacidade e segurança são prioridades e nos
              comprometemos com a transparência do tratamento de dados pessoais
              dos nossos usuários/clientes. Por isso, nossa Política de
              Privacidade estabelece quais dados são coletados, como é feita a
              coleta e o uso e transferência dessas informações de clientes ou
              outras pessoas que acessam ou usam nosso site.
            </p>

            <p class="texto">
              Ao utilizar nossos serviços, você entende que coletaremos e
              usaremos suas informações pessoais nas formas descritas nesta
              Política, sob as normas de Proteção de Dados (LGPD, Lei Federal
              13.709/2018), das disposições consumeristas da Lei Federal
              8078/1990 e as demais normas do ordenamento jurídico brasileiro
              aplicáveis. Assim, nossa Política de Privacidade visa garantir
              nosso compromisso com a sociedade em total concordância com a Lei
              Geral de Proteção de Dados Pessoais (LGPD).
            </p>
            <div v-for="topico in this.topicos" :key="topico.id">
              <div class="topico">
                <h2 class="titulo-topico">{{ topico.title }}</h2>
                <div class="conteiner-textos">
                  <p class="texto" v-for="texto in topico.texts" :key="texto">
                    <span v-html="texto"></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";

import Banner from "../shared/Banner";
import Block3 from "../shared/blocks/Block3";
import StormService from "../../domain/StormService";
import BannerService from "../../domain/bannerService";

export default {
  components: {
    Banner,
    Block3
  },
  watch: {
    "$i18n.locale": function() {
      this.init();
    }
  },
  data() {
    return {
      titulo: "Política de Privacidade",
      content: null,
      figure: null,
      bg_color: null,
      image: "/static/drones.png",
      blocks: [],
      banner: []
    };
  },
  methods: {
    init() {
      Vue.http.headers.common["Content-Language"] = this.$i18n.locale;
      this.topicos = [
        {
          id: 1,
          title: "INFORMAÇÕES GERAIS",
          texts: [
            "A presente Política de Privacidade contém informações sobre coleta, uso, armazenamento, tratamento e proteção dos dados pessoais dos usuários e visitantes do aplicativo do site, com a finalidade de demonstrar absoluta transparência quanto ao assunto e esclarecer a todos interessados sobre os tipos de dados que são coletados, os motivos da coleta e a forma como os usuários podem gerenciar ou excluir as suas informações pessoais.",

            "Esta Política de Privacidade aplica-se a todos os usuários e visitantes do site e integra os Termos e Condições Gerais de Uso do site da STORM GROUP, devidamente inscrita no CNPJ sob o nº 03.801.483/0001-11, situado em Avenida João Cabral de Melo Neto, 850, Bl.02, salas 304 a 307,Ed. CEO Corporate, Barra da Tijuca/RJ, doravante nominada STORM GROUP.",

            "O presente documento foi elaborado em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei 13.709/18), o Marco Civil da Internet (Lei 12.965/14) (e o Regulamento da UE n. 2016/6790). Ainda, o documento poderá ser atualizado em decorrência de eventual atualização normativa, razão pela qual se convida o usuário a consultar periodicamente esta seção."
          ]
        },
        {
          id: 2,
          title: "COMO COLETAMOS OS DADOS PESSOAIS DO USUÁRIO E DO VISITANTE",
          texts: [
            "Os dados pessoais do usuário e visitante são recolhidos pela plataforma através de cookies, do fale conosco, dos recebimentos dos currículos e pedido de inscrição na Newsletter."
          ]
        },
        {
          id: 3,
          title: "QUAIS DADOS PESSOAIS RECOLHEMOS SOBRE O USUÁRIO E VISITANTE",
          texts: [
            "A STORM GROUP obtém dados pessoais dos seus usuários e visitantes conforme definido no Art. 5º da Lei Nº 13.709/2018, registrand preferencialmente: e-mail, nome completo, cidade de residência, informações profissionais (Curriculum Vitae).",

            "Poderão ser registrados, também, dados anonimizados, para otimização de navegação, como: acesso a páginas, palavras-chave utilizadas na busca, recomendações, comentários.",

            "A STORM GROUP, por meio da plataforma, poderá coletar dados sensíveis dos usuários e visitantes, como: origem étnica ou racial, opinião política, convicção religiosa, dados genéticos, dados relativos à saúde, orientação sexual.",

            "Observação: o e-mail cadastrado na newsletter pelo usuário ou visitante, que optar por se inscrever, será coletado e armazenado até que o usuário solicite o descadastro.",

            "Observação: em relação à formalização de contratos ou de prestação de serviços entre a plataforma e o usuário e visitante, poderão ser coletados e armazenados dados relativos à execução contratual, inclusive as comunicações realizadas entre a empresa e o usuário."
          ]
        },
        {
          id: 4,
          title:
            "PARA QUE FINALIDADES UTILIZAMOS OS DADOS PESSOAIS DO USUÁRIO E VISITANTE",
          texts: [
            "Os dados pessoais do usuário e do visitante coletados e armazenados pelo site tem por finalidade:",

            "Aprimorar o produto e/ou serviço oferecido, facilitar, agilizar e cumprir os compromissos estabelecidos entre o usuário e a empresa, melhorar a experiência dos usuários e fornecer funcionalidades específicas a depender das características básicas do usuário.",

            "Melhor a plataforma: compreender como o usuário utiliza os serviços da plataforma, para ajudar no desenvolvimento de negócios e técnicas.",

            "Apresentar anúncios personalizados para o usuário com base nos dados fornecidos.",

            "Comercial: os dados são usados para personalizar o conteúdo oferecido e gerar subsídio à plataforma para a melhora da qualidade no funcionamento dos serviços. ",

            "Marketing direto (newsletter) com informações de novos serviços, projetos, produtos, eventos e/ou informações institucionais;",

            "Previsão do perfil do usuário: tratamento automatizados de dados pessoais para avaliar o uso na plataforma.",

            "Dados de cadastro: para permitir o acesso do usuário a determinados conteúdos da plataforma, exclusivo para usuários cadastrados.",

            "Dados de contrato: conferir às partes segurança jurídica e facilitar a conclusão do negócio.",

            "O tratamento de dados pessoais para finalidades não previstas nesta Política de Privacidade somente ocorrerá mediante comunicação prévia ao usuário, de modo que os direitos e obrigações aqui previstos permanecem aplicáveis."
          ]
        },
        {
          id: 5,
          title: "POR QUANTO TEMPO OS DADOS PESSOAIS FICAM ARMAZENADOS",
          texts: [
            "Os dados pessoais do usuário e visitante são armazenados pela plataforma durante o período necessário para a prestação do serviço ou o cumprimento das finalidades previstas no presente documento, conforme o disposto no inciso I do artigo 15 da Lei 13.709/18.",

            "Os dados podem ser removidos ou anonimizados a pedido do usuário, excetuando os casos em que a lei oferecer outro tratamento. ",

            "Ainda, os dados pessoais dos usuários apenas podem ser conservados após o término de seu tratamento nas seguintes hipóteses previstas no artigo 16 da referida lei: ",

            "I - Cumprimento de obrigação legal ou regulatória pelo controlador;",
            "II - Estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;",
            "III - Transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei;",
            "IV - Uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados."
          ]
        },
        {
          id: 6,
          title: "SEGURANÇA DOS DADOS PESSOAIS ARMAZENADOS",
          texts: [
            "A <em><strong>STORM GROUP</strong></em> se compromete a aplicar todas as medidas técnicas e organizacionais aptas a proteger os seus dados pessoais de acessos não autorizados e de situações de destruição, perda, alteração, comunicação ou difusão de tais dados.",

            "A <em><strong>STORM GROUP</strong></em> tem regras rígidas no intuito de proteger seus dados de qualquer uso indevido, através da implementação de controles, encriptação para que seus dados fiquem anônimos.",

            "A <em><strong>STORM GROUP</strong></em> não se exime de responsabilidade por culpa exclusiva do usuário, como no caso em que ele mesmo transfere seus dados a terceiros. ",

            "Os dados pessoais armazenados são tratados com confidencialidade, dentro dos limites legais. No entanto, podemos divulgar suas informações pessoais caso sejamos obrigados pela lei para fazê-lo."
          ]
        },
        {
          id: 7,
          title: "COMPARTILHAMENTO DOS DADOS",
          texts: [
            "O compartilhamento de dados do usuário ocorre apenas com os dados referentes a publicações realizadas pelo próprio usuário, tais ações são compartilhadas publicamente com os outros usuários.",

            "Os dados do perfil do usuário são compartilhados dentro da plataforma e com empresas do mesmo grupo econômico ou parceiros sendo permitido ao usuário solicitar que seu perfil não apareça nos resultados de busca de tais ferramentas.",

            "Nossos acordos contratuais são regidos e baseados na proteção da LGPD."
          ]
        },
        {
          id: 8,
          title:
            "7.1 OS DADOS PESSOAIS ARMAZENADOS SERÃO TRANSFERIDOS A TERCEIROS",
          texts: [
            "Os cookies referem-se a arquivos de texto enviados pela plataforma ao computador do usuário e visitante e que nele ficam armazenados, com informações relacionadas à navegação no site. ",
            "Tais informações são relacionadas aos dados de acesso como local e horário de acesso e são armazenadas pelo navegador do usuário e visitante para que o servidor da plataforma possa lê-las posteriormente a fim de personalizar os serviços da plataforma.",
            "O usuário e o visitante da plataforma manifesta conhecer e aceitar que pode ser utilizado um sistema de coleta de dados de navegação mediante à utilização de cookies.",
            "O cookie persistente permanece no disco rígido do usuário e visitante depois que o navegador é fechado e será usado pelo navegador em visitas subsequentes ao site. Os cookies persistentes podem ser removidos seguindo as instruções do seu navegador. Já o cookie de sessão é temporário e desaparece depois que o navegador é fechado. É possível redefinir seu navegador da web para recusar todos os cookies, porém alguns recursos da plataforma podem não funcionar corretamente se a capacidade de aceitar cookies estiver desabilitada."
          ]
        },
        {
          id: 9,
          title: "CONSENTIMENTO",
          texts: [
            "Ao utilizar os serviços e fornecer as informações pessoais na plataforma, o usuário está consentindo com a presente Política de Privacidade, conforme Art. 7º da Lei 13.709/2018.",

            "O usuário, ao cadastrar-se, manifesta conhecer e pode exercitar seus direitos de cancelar seu cadastro, acessar e atualizar seus dados pessoais e garante a veracidade das informações por ele disponibilizadas.",

            "O usuário tem direito de retirar o seu consentimento a qualquer tempo, para tanto deve entrar em contato através do e-mail <a href=mailto:<nowiki>dpo@stormgroup.com.br.</a>"
          ]
        },
        {
          id: 10,
          title: "SEUS DIREITOS SOBRE OS SEUS DADOS",
          texts: [
            "Conforme Art. 18º da Lei 13.709/2018, em qualquer tempo, o usuário ou visitante pode requisitar a STORM GROUP:",
            "I - Confirmação da existência de tratamento;",
            "II - Acesso aos dados;",
            "III - Correção de dados incompletos, inexatos ou desatualizados;",
            "IV - Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto nesta Lei;",
            "V - Portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa, de acordo com a regulamentação da autoridade nacional, observados os segredos comercial e industrial;",
            "VI - Eliminação dos dados pessoais tratados com o consentimento do titular, exceto nas hipóteses previstas no art. 16 desta Lei;",
            "VII - Informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados;",
            "VIII - Informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;",
            "IX - Revogação do consentimento, nos termos do § 5º do art. 8º desta Lei;",
            "Ressaltamos que, sua requisição poderá não ser imediatamente e integralmente satisfeita, em razão de algum impedimento e para o cumprimento de obrigações legais"
          ]
        },
        {
          id: 11,
          title: "ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE",
          texts: [
            "Reservamos o direito de modificar essa Política de Privacidade a qualquer momento, então, é recomendável que o usuário e visitante revise-a com frequência",

            "As alterações e esclarecimentos vão surtir efeito imediatamente após sua publicação na plataforma. Ao utilizar o serviço ou fornecer informações pessoais após eventuais modificações, o usuário e visitante demonstra sua concordância com as novas normas.",

            "Diante da fusão ou venda da plataforma à outra empresa os dados dos usuários podem ser transferidas para os novos proprietários para a permanência dos serviços oferecidos."
          ]
        },
        {
          id: 12,
          title: "CONTRATE A STORM PARA PROTEGER SEUS DADOS",
          texts: [
            "Você pode proteger seus dados e da sua empresa, exercer todos os direitos previstos na LGPD (Lei Geral de Proteção de Dados), e em nossa Política de Privacidade de Dados, além de resolver quaisquer dúvidas relacionadas ao Tratamento dos Dados Pessoais. Basta nos contatar em e-mail <a href=mailto:<nowiki>dpo@stormgroup.com.br.</a>"
          ]
        },
        {
          id: 13,
          title: "JURISDIÇÃO PARA RESOLUÇÃO DE CONFLITOS",
          texts: [
            "A presente Política de Privacidade é regida pela Lei Geral de Proteção de Dados Pessoais (Lei 13.709/18), o Marco Civil da Internet (Lei 12.965/14) (e o Regulamento da UE n. 2016/6790.",
            "Para a solução de controvérsias decorrentes do presente instrumento será aplicado integralmente o Direito brasileiro.",
            "Os eventuais litígios deverão ser apresentados no Foro Da Comarca Regional da Barra da Tijuca/RJ em que se encontra a sede da empresa."
          ]
        }
      ];
      this.banner = {
        title: "Política de Privacidade",
        image: "/static/politica_privacidade.png",
        respimage: "/static/politica_privacidade.png"
      };

      this.stormSerivce.blocks().then(res => {
        this.blocks = res;
        console.log("res 123", res);

        return this.block;
      });

      // this.bannerService.blocks().then(res => {
      //   this.banner = res;
      //   this.banner = this.banner[0];
      //   return this.banner;
      // });
    }
  },
  created() {
    this.stormSerivce = new StormService(this.$resource);
    // this.bannerService = new BannerService(this.$resource, "SOBRE");
    this.bannerService = new BannerService(this.$resource, "BLOG");
    this.init();
    this.removeTags();
  }
};
</script>

<style lang="scss">
.blocks {
  .container {
    .article-blocks {
      .texto {
        color: #222831;
        font-size: 1.6em;
        line-height: 24px;
        width: 100% !important;
        margin: 0 auto 25px auto;
      }
      .topico {
        gap: 35px;
        width: 90%;
        display: flex;
        margin-bottom: 30px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/politicaDePrivacidade/politicaDePrivacidade.vue